import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseMenuContent() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات منو را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getMenuList = (search, ParentID, callback, bool) => {
    let myPC = {
      ParentID: ParentID,
    };
    MyAxios.get(`Admin_MenuManagment?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllMenuList = (callback) => {
    let myPC = {
      parentID: "",
      groupID: "",
      pageCount: 1,
    };

    MyAxios.get(`Admin_MenuManagment?w=`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getMenuByID = (id, callback) => {
    MyAxios.get(`Admin_MenuManagment/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateMenu = (state, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    data.append("file", file);
    MyAxios.put(`Admin_MenuManagment`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("منو با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addMenu = (state, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    data.append("file", file);
    MyAxios.post(`Admin_MenuManagment`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("منو با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteMenu = (MenuID, callback) => {
    const data = new FormData();
    data.append("MenuID", MenuID);
    MyAxios.delete(`Admin_MenuManagment`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("منو با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addMenuAdv = (state, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    data.append("file", file);
    MyAxios.post(`Admin_MenuManagment/AddMenuAdv`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("آگهی با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const RemoveMenuAdv = (MenuADVID, callback) => {
    const data = new FormData();
    data.append("MenuADVID", MenuADVID);
    MyAxios.delete(`Admin_MenuManagment/RemoveMenuAdv`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("منو با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const getSteps = (Steps) => {
    let steps = Steps ? Steps : undefined;

    if (steps) {
      return steps.map((s) => parseInt(s));
    }
    return steps;
  };

  const removeLastSteps = (Step) => {
    let steps = getSteps(Step);
    steps.pop();
    return steps;
  };

  const addToSteps = (Step, id) => {
    let steps = getSteps(Step) ? getSteps(Step) : [];
    steps.push(id);
    return steps;
  };

  return {
    getMenuList,
    validate,
    updateMenu,
    addMenu,
    deleteMenu,
    getAllMenuList,
    getSteps,
    removeLastSteps,
    addToSteps,
    getMenuByID,
    RemoveMenuAdv,
    addMenuAdv,
  };
}
